import {convertToSearchParams, getFormattedSearchParams} from './getSearchParamsByGridCode';

export const removeSearchParamsByGridCode = (gridCode: string) => {
  const formattedSearchParams = getFormattedSearchParams();

  if (!formattedSearchParams[gridCode]) {
    return;
  }

  delete formattedSearchParams[gridCode];

  const {origin, pathname} = window.location;
  const hasRemainingDataGrids = Object.keys(formattedSearchParams).length > 0;

  if (!hasRemainingDataGrids) {
    window.history.replaceState(null, '', origin + pathname);
    return;
  }

  const params = new URLSearchParams(convertToSearchParams(formattedSearchParams));
  window.history.replaceState(null, '', `${origin}${pathname}?${params}`);
};
